import Menus from '../../components/menus/menus'
import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { MenuModeEnum } from '../../share-types'
import { Card, Space } from 'antd'
import React, { Component } from 'react'

class Home extends Component {
  render(): React.ReactNode {
    return (
      <Space className="dashboard-wrapper" orientation="vertical">
        <NavBar title={translate('welcome')}></NavBar>
        <Card>
          <Menus mode={MenuModeEnum.GRID} />
        </Card>
      </Space>
    )
  }
}

export default Home
